import FundPlannerLgipWorkflow from "./workflows/fundPlannerLgip/FundPlannerLgipWorkflow";

const WORKFLOWS = {
  "fund-planner.lgip-monthly-statement": { module: "fund-planner", inputKind: "account-statement", component: FundPlannerLgipWorkflow },
};

export function getSmartDocWorkflow(code) { return WORKFLOWS[code] || null; }
